document.addEventListener("scroll", function () {
  var circle = document.getElementById("circle");
  var scrollAmount = window.pageYOffset || document.documentElement.scrollTop;

  // This is where you decide how the circle moves as you scroll
  // For example, moving the circle down by 1px for every 10px scrolled
  var newPosition = 20 + scrollAmount / 10;

  circle.style.top = newPosition + "px";
});
